import Request from "@services/request";
import { IGetAllFormData, IGetSingleFormData } from "./types";

const GetAllWithoutFilter = async () =>
    await new Request().get<IReturnValue<Array<IBrands["get"]>>>("BRANDS_ALL");

const GetAll = async ({ query, page }: IGetAllFormData) =>
    await new Request().get<IReturnValue<Array<IBrands["get"]>>>("BRANDS", {
        params: {
            query,
            page,
        },
    });

const GetSingle = async ({ id }: IGetSingleFormData) =>
    await new Request().get<IReturnValue<IBrand["get"]>>({
        base: "BRAND",
        params: {
            id,
        },
    });

const Create = async ({
    faName,
    enName,
    url,
    description,
    seoDescription,
    seoKeywords,
}: IBrands["post"]) =>
    await new Request().post<IBrands["post"], IReturnValue<any>>("BRANDS", {
        faName,
        enName,
        url,
        description,
        seoDescription,
        seoKeywords,
    });

const Edit = async ({
    id,
    faName,
    enName,
    url,
    description,
    seoDescription,
    seoKeywords,
}: IBrand["put"]) =>
    await new Request().put<Omit<IBrand["put"], "id">, IReturnValue<any>>(
        {
            base: "BRAND",
            params: {
                id,
            },
        },
        {
            faName,
            enName,
            url,
            description,
            seoDescription,
            seoKeywords,
        },
    );

const Delete = async ({ id }: IBrand["delete"]) =>
    await new Request().delete<IReturnValue<any>>({
        base: "BRAND",
        params: {
            id,
        },
    });

const UploadFile = async ({ id, file }: { id: number; file: File }) => {
    const formData = new FormData();

    formData.append("image", file);

    return await new Request().post<
        FormData,
        IReturnValue<{
            url: string;
        }>
    >(
        {
            base: "BRAND_IMAGE",
            params: {
                id,
            },
        },
        formData,
    );
};

const DeleteImage = async ({ id }: IBrand["delete"]) =>
    await new Request().delete<IReturnValue<any>>({
        base: "BRAND_IMAGE",
        params: {
            id,
        },
    });

// Main Object
const BrandsApis = {
    GetAllWithoutFilter,
    GetAll,
    GetSingle,
    Create,
    Edit,
    Delete,
    UploadFile,
    DeleteImage,
};

export default BrandsApis;
